<main class="p-4">
  @if (loading()) {
    <p>讀取說明資料中…</p>
  } @else if (message()) {
    <p>{{ message() }}</p>
  } @else if (data) {
    <div class="mb-4 flex gap-2">
      <button
        type="button"
        class="btn btn-sm"
        [disabled]="rowIndex === 0"
        (click)="previousRow()"
      >
        上一筆
      </button>
      <button
        type="button"
        class="btn btn-sm"
        [disabled]="rowIndex >= rows.length - 1"
        (click)="nextRow()"
      >
        下一筆
      </button>
    </div>
    <section class="mb-4">
      <p>程式代號: {{ data.SH001 }} 名稱: {{ data.SH002 }}</p>
      <p>建檔者代號: {{ data.SH013 }}</p>
    </section>

    <app-jk-rich-editor label="html內容" [value]="data.SH019" [readonly]="true">
    </app-jk-rich-editor>
  }
</main>
